import React from "react";
import { Link } from "react-router-dom";
import { PawPrint, HeartHandshake, PiggyBank, Users, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";

const points = [
  { icon: PiggyBank, title: "Fair, Honest Pricing", text: "Transparent prices so quality care never feels out of reach." },
  { icon: Users, title: "Inclusive for Pensioners", text: "Age-friendly service and gentle support for older owners and pets alike." },
  { icon: HeartHandshake, title: "Every Pet Provided For", text: "Compassionate care designed so no companion goes without." },
];

const AffordableCare = () => {
  return (
    <section className="bg-pawelle-bg py-20 md:py-28">
      <div className="mx-auto max-w-[1290px] px-5">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <Reveal animation="rubberBand">
              <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
                <PawPrint className="h-5 w-5" /> Affordable Care That's Always There
              </span>
            </Reveal>
            <Reveal animation="fadeInUp" delay={100}>
              <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
                Pets Are Not a Luxury — They Are Family
              </h2>
            </Reveal>
            <Reveal animation="fadeInUp" delay={150}>
              <p className="mt-5 max-w-xl font-body text-[16px] leading-relaxed text-pawelle-body">
                Our aim is to provide affordable care to ensure all pets can be provided for. We keep our
                pricing fair and our welcome warm — with older owners and pensioners firmly in mind — so every
                member of your family can get the treatment they deserve.
              </p>
            </Reveal>
            <Reveal animation="fadeInUp" delay={200}>
              <Link
                to="/gb/en/pricing-plan.html"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-pawelle-primary px-8 py-4 font-display text-[16px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark hover:-translate-y-0.5"
              >
                View Our Fair Prices <ArrowRight className="h-5 w-5" />
              </Link>
            </Reveal>
          </div>

          <div className="grid gap-5">
            {points.map((p, i) => {
              const Icon = p.icon;
              return (
                <Reveal
                  key={p.title}
                  animation="fadeInRight"
                  delay={i * 90}
                  className="group flex items-start gap-5 rounded-2xl bg-white p-6 shadow-[0_10px_30px_rgba(67,48,109,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(114,82,155,0.14)]"
                >
                  <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-pawelle-bg text-pawelle-primary transition-colors group-hover:bg-pawelle-primary group-hover:text-white">
                    <Icon className="h-7 w-7" />
                  </div>
                  <div>
                    <h3 className="font-display text-[20px] font-semibold text-pawelle-ink">{p.title}</h3>
                    <p className="mt-1.5 font-body text-[15px] leading-relaxed text-pawelle-body">{p.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AffordableCare;
